<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <mat-toolbar color="warn">Menu</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink="/characters">Characters</a>
      <a mat-list-item routerLink="/comics">Comics</a>
      <a mat-list-item routerLink="/series">Series</a>
      <a mat-list-item routerLink="/creators">Creators</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="warn">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Marvel-Angular</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <app-loader></app-loader>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
